import React from 'react';
import { AppBar, Toolbar, Typography,  IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
 
export default function Navbar() {
    

  return (
    <AppBar position="static" sx={{ backgroundColor: '#2389DA' }}>

      <Toolbar>
        <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Logo
        </Typography>
        
      </Toolbar>
    </AppBar>
  );
}
